var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "base-alert",
        {
          attrs: { variant: "success", time: 2 },
          model: {
            value: _vm.alertVisible,
            callback: function($$v) {
              _vm.alertVisible = $$v
            },
            expression: "alertVisible"
          }
        },
        [_vm._v("Pruebas")]
      ),
      _vm._v(" "),
      _c(
        "b-container",
        { staticClass: "pt-5" },
        [
          _c(
            "b-row",
            {
              staticClass: "vh-100 mx-auto text-center",
              attrs: { "align-v": "center" }
            },
            [
              _c("base-birthdate-input", {
                model: {
                  value: _vm.birthDate,
                  callback: function($$v) {
                    _vm.birthDate = $$v
                  },
                  expression: "birthDate"
                }
              }),
              _vm._v(" "),
              _c("button", { on: { click: _vm.throwError } }, [
                _vm._v("Throw error")
              ]),
              _vm._v(" "),
              _c("span", [_vm._v(_vm._s(_vm.birthDate))]),
              _vm._v(" "),
              _c(
                "b-col",
                { attrs: { cols: "12" } },
                [
                  _vm._v("\n          Base buttons\n          "),
                  _c(
                    "b-row",
                    [
                      _c(
                        "base-button",
                        { attrs: { blue: "" }, on: { click: _vm.showDialog } },
                        [_vm._v("Mostrar dialog")]
                      ),
                      _vm._v(" "),
                      _c(
                        "base-button",
                        {
                          attrs: { white: "", shadow: "" },
                          on: {
                            click: function($event) {
                              return _vm.$helpers.goToWebApp(
                                "HomePaciente/#/appointments/review/"
                              )
                            }
                          }
                        },
                        [_vm._v("Prueba webapp")]
                      ),
                      _vm._v(" "),
                      _c("base-button", { attrs: { red: "" } }, [
                        _vm._v("Volver a intentar")
                      ]),
                      _vm._v(" "),
                      _c(
                        "base-button",
                        { attrs: { gray: "" }, on: { click: _vm.showDialog } },
                        [_vm._v("Volver")]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    { staticClass: "mt-4" },
                    [
                      _c(
                        "base-button",
                        {
                          attrs: { blue: "", outline: "" },
                          on: { click: _vm.showDialog }
                        },
                        [_vm._v("Continuar")]
                      ),
                      _vm._v(" "),
                      _c("base-button", { attrs: { red: "", outline: "" } }, [
                        _vm._v("Volver a intentar")
                      ]),
                      _vm._v(" "),
                      _c(
                        "base-button",
                        {
                          attrs: { gray: "", outline: "" },
                          on: { click: _vm.showDialog }
                        },
                        [_vm._v("Volver")]
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                { attrs: { cols: "12" } },
                [
                  _vm._v("\n          Bootstrap B-tabs\n          "),
                  _c(
                    "b-tabs",
                    { attrs: { fill: "" } },
                    [
                      _c(
                        "b-tab",
                        {
                          attrs: {
                            title: "Mi perfil",
                            active: _vm.activeTab == "profile"
                          }
                        },
                        [_vm._v("\n              Mi perfil\n            ")]
                      ),
                      _vm._v(" "),
                      _c(
                        "b-tab",
                        {
                          attrs: {
                            title: "Mis servicios",
                            active: _vm.activeTab == "services"
                          }
                        },
                        [_vm._v("\n              Mis servicios\n            ")]
                      ),
                      _vm._v(" "),
                      _c(
                        "b-tab",
                        {
                          attrs: {
                            title: "Chats",
                            active: _vm.activeTab == "chats"
                          }
                        },
                        [_vm._v("\n              Chats\n            ")]
                      ),
                      _vm._v(" "),
                      _c(
                        "b-tab",
                        {
                          attrs: {
                            title: "Mis consultas",
                            active: _vm.activeTab == "appointments"
                          }
                        },
                        [_vm._v("\n              Mis consultas\n            ")]
                      ),
                      _vm._v(" "),
                      _c(
                        "b-tab",
                        {
                          attrs: {
                            title: "Solicitudes de cita (1)",
                            active: _vm.activeTab == "requests"
                          }
                        },
                        [
                          _vm._v(
                            "\n              Solicitudes de cita (1)\n            "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "b-tab",
                        {
                          attrs: {
                            title: "Mi agenda",
                            active: _vm.activeTab == "scheduler"
                          }
                        },
                        [_vm._v("\n              Mi agenda\n            ")]
                      ),
                      _vm._v(" "),
                      _c(
                        "b-tab",
                        {
                          attrs: {
                            title: "Mis pacientes",
                            active: _vm.activeTab == "patients"
                          }
                        },
                        [_vm._v("\n              Mis pacientes\n            ")]
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                { attrs: { cols: "12" } },
                [
                  _vm._v("\n          Base Radio Group\n          "),
                  _c("base-radio-group", {
                    attrs: { options: _vm.radioGroup.options },
                    model: {
                      value: _vm.radioGroup.selected,
                      callback: function($$v) {
                        _vm.$set(_vm.radioGroup, "selected", $$v)
                      },
                      expression: "radioGroup.selected"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                { attrs: { cols: "12" } },
                [
                  _vm._v("\n          Binary Radio Group\n          "),
                  _c("binary-radio-group", {
                    model: {
                      value: _vm.binRadioGroup.selected,
                      callback: function($$v) {
                        _vm.$set(_vm.binRadioGroup, "selected", $$v)
                      },
                      expression: "binRadioGroup.selected"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                { attrs: { cols: "12" } },
                [
                  _vm._v("\n          Switches\n          "),
                  _c(
                    "b-form-checkbox",
                    {
                      attrs: { switch: "" },
                      model: {
                        value: _vm.switchObj.selected,
                        callback: function($$v) {
                          _vm.$set(_vm.switchObj, "selected", $$v)
                        },
                        expression: "switchObj.selected"
                      }
                    },
                    [
                      _c("img", {
                        staticClass: "nav-item-icon",
                        attrs: {
                          src:
                            "/static-appopensalud/img/icons/stethoscope-gray.svg"
                        }
                      }),
                      _vm._v(
                        _vm._s(_vm.$t("enable-stethoscope")) + "\n          "
                      )
                    ]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                { attrs: { cols: "12" } },
                [
                  _vm._v("\n          Base Select\n          "),
                  _c("base-select", {
                    attrs: {
                      label: "text",
                      options: _vm.formSelect.options,
                      dataAttributes: [{ key: "paytpv", value: "prueba" }]
                    },
                    model: {
                      value: _vm.formSelect.selected,
                      callback: function($$v) {
                        _vm.$set(_vm.formSelect, "selected", $$v)
                      },
                      expression: "formSelect.selected"
                    }
                  }),
                  _vm._v(" "),
                  _c("base-select", {
                    attrs: {
                      label: "text",
                      options: _vm.formSelect.options,
                      valueProp: "customValue"
                    },
                    model: {
                      value: _vm.formSelect.selected,
                      callback: function($$v) {
                        _vm.$set(_vm.formSelect, "selected", $$v)
                      },
                      expression: "formSelect.selected"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                { attrs: { cols: "12" } },
                [
                  _vm._v("\n          Highcharts\n          "),
                  _c("highcharts", { attrs: { options: _vm.chartOptions } })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                { attrs: { cols: "12" } },
                [
                  _c(
                    "b-button",
                    {
                      attrs: { variant: "primary" },
                      on: {
                        click: function($event) {
                          _vm.consolidateAppointmentModal.visible = true
                        }
                      }
                    },
                    [_vm._v("Modal consolidación de\n            consulta")]
                  ),
                  _vm._v(" "),
                  _c("consolidate-appointment-modal", {
                    attrs: {
                      isBillable: _vm.consolidateAppointmentModal.isBillable
                    },
                    on: { consolidate: _vm.onConsolidate },
                    model: {
                      value: _vm.consolidateAppointmentModal.visible,
                      callback: function($$v) {
                        _vm.$set(
                          _vm.consolidateAppointmentModal,
                          "visible",
                          $$v
                        )
                      },
                      expression: "consolidateAppointmentModal.visible"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("base-dialog", {
            attrs: {
              okFn: _vm.okFn,
              cancelFn: _vm.cancelFn,
              content: "¿Está seguro de que desea continuar?"
            },
            model: {
              value: _vm.dialogVisible,
              callback: function($$v) {
                _vm.dialogVisible = $$v
              },
              expression: "dialogVisible"
            }
          }),
          _vm._v(" "),
          _c("stethoscope-modal", { ref: "stethoscopeModal" })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-52a1dda3", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-52a1dda3","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/testing/ComponentTesting.vue
// module id = 3959
// module chunks = 66